export default {
  suez: "'Suez One', serif",
  raleway: "'Raleway', sans-serif",
};
